import React from 'react'
import ReactDOM from 'react-dom/client'
import 'sweetalert2/dist/sweetalert2.min.css'
import './utils/htdSwal'
import { startDeployVersionGuard } from '@huay/shared/deployVersionGuard'
import App from './App'
import './index.css'
import './styles/htd-theme.css'
import './styles/htd-modals.css'

startDeployVersionGuard({ appName: 'user-htd' })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
